import tooltip from "wsdm-tooltip"

const stylesToString = styles => {
  let string = ""
  for (const key in styles) {
    if (Object.prototype.hasOwnProperty.call(styles, key)) {
      string += `${key}: ${styles[key]};`
    }
  }
  return string
}

export const tooltipStyle = {
  padding: "0.5rem 1rem",
  background: "#fff",
  "border-radius": "3px",
  "text-align": "center",
  "box-shadow": "0 2px 16px rgba(0,0,0,0.2)",
}
export const tooltipStyleString = stylesToString(tooltipStyle)

export const arrowStyle = {
  position: "absolute",
  width: 0,
  height: 0,
  top: "100%",
  left: "50%",
  "margin-left": "-0.5rem",
  "border-left": "0.5rem solid transparent",
  "border-right": "0.5rem solid transparent",
  "border-top": "0.5rem solid rgba(255, 255, 255, 0.95)",
}
export const arrowStyleString = stylesToString(arrowStyle)

// simple proxy for wsdm-tooltip
// allows to apply datastory styling to the chart tooltips
// and adds the arrow
export const ChartTooltip = (
  options = { styles: tooltipStyle, hasArrow: true }
) => {
  const tip = tooltip(options)

  // add bottom arrow
  function show(content) {
    if (options.hasArrow) content += `<div style="${arrowStyleString}"></div>`
    tip.show(content)
  }

  // apply default offset to account for the arrow
  function position(e, offset = [0, -15]) {
    tip.position(e, offset)
  }

  return {
    show: show,
    position: position,
    create: tip.create,
    hide: tip.hide,
  }
}
